import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { Form, withFormik } from 'formik';
import compose from 'lodash/fp/compose';

import BrandsDropdown from '../../../../shared/components/brands-dropdown/brands-dropdown';
import ModelsDropdown from '../../../../shared/components/models-dropdown/models-dropdown';
import { withHigherOrderComponent } from '../../../../shared/components/with-higher-order-component/with-higher-order-component';
import { useNoSubmit } from '../../../../shared/hooks/use-no-submit/use-no-submit.hook';
import Filter from '../../../shared/components/filter/Filter';
import StatusDropdown from './components/status-dropdown/status-dropdown';
import { CampaignFiltersFormikModel } from './models/campaign-filters-formik.model';
import { CampaignFilterProps } from './types/campaign-filter.props';

const CampaignsFiltersContainer: FunctionComponent<CampaignFilterProps> = (
  props: PropsWithChildren<CampaignFilterProps>
): ReactElement => {
  const { children, handleSubmit } = props;

  return (
    <Form onSubmit={handleSubmit}>
      <Filter>{children}</Filter>
    </Form>
  );
};

export default withFormik<
  Record<string, unknown>,
  CampaignFiltersFormikModel
>({
  handleSubmit: useNoSubmit(),
})(
  compose(
    withHigherOrderComponent(BrandsDropdown),
    withHigherOrderComponent(ModelsDropdown),
    withHigherOrderComponent(StatusDropdown)
  )(CampaignsFiltersContainer)
);
